import { Directive, forwardRef, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[passwordEqual][formControlName],[passwordEqual][formControl],[passwordEqual][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => PasswordEqualValidatorDirective), multi: true }
    ],
    standalone: false
})
export class PasswordEqualValidatorDirective implements Validator {
    @Input() public passwordEqual: string;
    @Input() public reverse: string;
    constructor() {

    }
    private get isReverse() {
        if (!this.reverse) { return false; }
        return this.reverse === 'true' ? true : false;
    }
    validate(c: AbstractControl): { [key: string]: any } {
        const v = c.value;
        const e = c.root.get(this.passwordEqual);
        if (e && v !== e.value && !this.isReverse) {
            return {
                isValid: { message: 'Password Mismatch' }
            };
        }

        if (e && v === e.value && this.isReverse) {
            delete e.errors['passwordEqual'];
            if (!Object.keys(e.errors).length) { e.setErrors(null); }
        }
        if (e && v !== e.value && this.isReverse) {
            e.setErrors({
                isValid: { message: 'Password Mismatch' }
            });
        }
        return null;
    }
}
